/* MarieOdile productpagina: galerij, variantselectie en add to cart.
   Sectie-gescoped, idempotent, bestand tegen Theme Editor section reloads.
   Variantlogica draait op de echte variant-data van Shopify. */
(function () {
  'use strict';

  function initProduct(root) {
    if (!root || root.dataset.moInit === '1') return;
    root.dataset.moInit = '1';

    var data = root.querySelector('[data-mo-variants]');
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { variants = []; }

    var stage = root.querySelector('[data-mo-stage]');
    var thumbsTrack = root.querySelector('[data-mo-thumbs]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-mo-thumb]'));
    var slides = [].slice.call(root.querySelectorAll('[data-mo-slide]'));
    var idInput = root.querySelector('[data-mo-variant-id]');
    var priceEl = root.querySelector('[data-mo-price]');
    var atc = root.querySelector('[data-mo-atc]');
    var atcText = root.querySelector('[data-mo-atc-text]');
    var colorLabel = root.querySelector('[data-mo-color-label]');
    var current = 0;
    var timers = [];

    /* ── Galerij ── */
    function slideStep() {
      if (slides.length < 2) return slides.length ? slides[0].getBoundingClientRect().width : 0;
      return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    }
    function thumbStep() {
      if (thumbs.length < 2) return 0;
      return thumbs[1].getBoundingClientRect().top - thumbs[0].getBoundingClientRect().top;
    }
    function goTo(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      if (stage) stage.style.transform = 'translateX(' + (-current * slideStep()) + 'px)';
      thumbs.forEach(function (t, k) { t.classList.toggle('is-current', k === current); });
      if (thumbsTrack && thumbs.length > 4) {
        var first = Math.max(0, Math.min(current - 1, thumbs.length - 4));
        thumbsTrack.style.transform = 'translateY(' + (-first * thumbStep()) + 'px)';
      }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    var prev = root.querySelector('[data-mo-gal-prev]');
    var next = root.querySelector('[data-mo-gal-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    /* ── Varianten ── */
    function selectedOptions() {
      return [].slice.call(root.querySelectorAll('[data-mo-option]:checked')).map(function (i) { return i.value; });
    }
    function findVariant() {
      var sel = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var k = 0; k < sel.length; k++) {
          if (v.options[k] !== sel[k]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var v = findVariant();
      if (idInput) idInput.value = v ? v.id : '';
      if (priceEl && v && v.price_html) priceEl.innerHTML = v.price_html;
      if (atc) {
        var unavailable = !v || !v.available;
        atc.disabled = unavailable;
        if (atcText) atcText.textContent = !v ? atc.dataset.unavailable : (v.available ? atc.dataset.label : atc.dataset.soldout);
      }
      /* media van de variant tonen */
      if (v && v.media_index != null && v.media_index >= 0) goTo(v.media_index);
      /* De zichtbare keuze verhuist mee: de radio's zijn verborgen, dus zonder
         dit blijft de eerste swatch en maat gemarkeerd staan. */
      root.querySelectorAll('.mo-swatch, .mo-pill').forEach(function (label) {
        var input = label.querySelector('input[data-mo-option]');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
      updateSizeBadges();
      if (typeof updateStock === 'function') updateStock(v);
      /* zichtbaar kleurlabel bijwerken */
      if (colorLabel) {
        var c = root.querySelector('[data-mo-option][data-option-position="1"]:checked');
        if (c) colorLabel.textContent = c.value;
      }
      /* URL bijwerken zodat delen en terugnavigeren de variant houdt */
      if (v && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }
    root.querySelectorAll('[data-mo-option]').forEach(function (i) {
      i.addEventListener('change', update);
    });

    /* ── Hoeveelheid ── */
    var qtyWrap = root.querySelector('[data-mo-qty]');
    if (qtyWrap) {
      qtyWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-dir]');
        if (!btn) return;
        var input = qtyWrap.querySelector('input');
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, btn.dataset.dir === '-' ? val - 1 : val + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* ── Accordions ── */
    root.querySelectorAll('[data-mo-acc-head]').forEach(function (h) {
      h.addEventListener('click', function () {
        var item = h.closest('[data-mo-acc]');
        var open = item.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });


    /* ── Scrollslot achter elke dialoog ──
       showModal() houdt de pagina eronder gewoon scrollbaar. Op mobiel scrolt
       de achtergrond dan weg onder de maattabel of de quiz door. Eén helper
       zet het slot en haalt het er bij het sluiten weer af; de teller houdt
       rekening met een tweede dialoog die bovenop de eerste opent. */
    function openDialoog(dlg) {
      if (!dlg || dlg.open) return;
      dlg.showModal();
      document.documentElement.classList.add('mo-noscroll');
      if (!dlg.dataset.moLockBound) {
        dlg.dataset.moLockBound = '1';
        dlg.addEventListener('close', function () {
          if (!document.querySelector('dialog[open]')) {
            document.documentElement.classList.remove('mo-noscroll');
          }
        });
      }
    }

    /* ── Zoom op productbeeld ── */
    var zoom = root.querySelector('[data-mo-zoom]');
    if (zoom) {
      var zoomImg = zoom.querySelector('img');
      root.querySelectorAll('.mo-zoomable').forEach(function (im) {
        im.addEventListener('click', function () {
          var slide = im.closest('[data-mo-slide]');
          zoomImg.src = (slide && slide.dataset.zoomSrc) || im.currentSrc || im.src;
          zoomImg.alt = im.alt || '';
          openDialoog(zoom);
        });
      });
      zoom.querySelector('[data-mo-zoom-close]').addEventListener('click', function () { zoom.close(); });
      zoom.addEventListener('click', function (e) { if (e.target === zoom) zoom.close(); });
    }

    /* ── Maattabel ── */
    var sizeModal = root.querySelector('[data-mo-size-modal]');
    if (sizeModal) {
      root.querySelectorAll('[data-mo-size-open]').forEach(function (b2) {
        b2.addEventListener('click', function () { openDialoog(sizeModal); });
      });
      var sc = sizeModal.querySelector('[data-mo-size-close]');
      if (sc) sc.addEventListener('click', function () { sizeModal.close(); });
      sizeModal.addEventListener('click', function (e) { if (e.target === sizeModal) sizeModal.close(); });
    }

    /* ── Maatquiz ──
       De vragen komen standaard uit de maattabel van dit product: elke kolom
       wordt een vraag, elke rij een maat. Zo kan het advies niet afwijken van
       de tabel. Staat de bron op "Lengte en gewicht", dan gebruikt hij de
       eigen regels uit het blok. */
    var quiz = root.querySelector('[data-mo-quiz]');
    if (quiz) {
      var qOpen = root.querySelector('[data-mo-quiz-open]');
      var qFields = quiz.querySelector('[data-mo-quiz-fields]');
      var qDots = quiz.querySelector('[data-mo-quiz-dots]');
      var qFitStep = quiz.querySelector('[data-mo-quiz-fit-step]');
      var qResult = quiz.querySelector('[data-mo-quiz-result]');
      var qNav = quiz.querySelector('[data-mo-quiz-nav]');
      var qNext = quiz.querySelector('[data-mo-quiz-next]');
      var qPrev = quiz.querySelector('[data-mo-quiz-prev]');
      var qSizeEl = quiz.querySelector('[data-mo-quiz-size]');
      var qReason = quiz.querySelector('[data-mo-quiz-reason]');
      var qApply = quiz.querySelector('[data-mo-quiz-apply]');
      var sizePos = parseInt(quiz.dataset.sizePosition, 10) || 1;
      var remember = quiz.dataset.remember === 'true';
      var STORE = 'mo-size-quiz';

      var maten = [];       /* [{maat, velden:[{vraag,eenheid,van,tot,min,max}]}] */
      var kolommen = [];    /* [{vraag, eenheid, min, max}] */
      var step = 1;
      var recommended = null;

      /* "84-88 cm" → {van:84, tot:88, eenheid:'cm'}; één getal telt als van=tot */
      function leesCel(txt) {
        var getallen = (txt.match(/\d+(?:[.,]\d+)?/g) || []).map(function (n) { return parseFloat(n.replace(',', '.')); });
        if (!getallen.length) return null;
        var eenheid = (txt.match(/[a-zA-Z"']+\s*$/) || [''])[0].trim();
        return { van: getallen[0], tot: getallen.length > 1 ? getallen[1] : getallen[0], eenheid: eenheid };
      }

      /* Bouwt de maten uit de maattabel die al op de pagina staat. */
      function uitMaattabel() {
        var tabel = root.querySelector('[data-mo-size-modal] table');
        if (!tabel) return [];
        var rijen = [].slice.call(tabel.querySelectorAll('tr'));
        if (rijen.length < 2) return [];
        var koppen = [].slice.call(rijen[0].querySelectorAll('th, td')).map(function (c) { return c.textContent.trim(); });
        var out = [];
        rijen.slice(1).forEach(function (tr) {
          var cellen = [].slice.call(tr.querySelectorAll('td, th'));
          if (cellen.length < 2) return;
          var velden = [];
          for (var i = 1; i < cellen.length; i++) {
            var r = leesCel(cellen[i].textContent);
            if (!r) continue;
            velden.push({
              vraag: quiz.dataset.measureQuestion.replace('{kolom}', (koppen[i] || '').toLowerCase()),
              eenheid: r.eenheid, van: r.van, tot: r.tot
            });
          }
          if (velden.length) out.push({ maat: cellen[0].textContent.trim(), velden: velden });
        });
        return out;
      }

      /* De maattabel bepaalt wélke maten bestaan en in welke volgorde. De
         eigen regels bepalen alleen bij welke lengte en gewicht je waar valt;
         die informatie staat niet in een tabel met bovenwijdte en taille. */
      function ladderUitTabel() {
        var tabel = root.querySelector('[data-mo-size-modal] table');
        if (!tabel) return [];
        return [].slice.call(tabel.querySelectorAll('tr')).slice(1).map(function (tr) {
          var eerste = tr.querySelector('td, th');
          return eerste ? eerste.textContent.trim() : '';
        }).filter(Boolean);
      }

      function uitInstelling() {
        try { return JSON.parse(quiz.querySelector('[data-mo-quiz-data]').textContent) || []; }
        catch (e) { return []; }
      }

      /* Grenzen per kolom: ruim om de tabel heen, zodat afwijkende maten mogen. */
      function bepaalKolommen() {
        kolommen = [];
        if (!maten.length) return;
        maten[0].velden.forEach(function (_, i) {
          var alle = maten.map(function (m) { return m.velden[i]; }).filter(Boolean);
          var laag = Math.min.apply(null, alle.map(function (v) { return v.van; }));
          var hoog = Math.max.apply(null, alle.map(function (v) { return v.tot; }));
          /* Ruime grenzen: wie buiten de tabel valt moet de quiz nog steeds
             kunnen afmaken en krijgt dan simpelweg de dichtstbijzijnde maat. */
          var marge = Math.max(25, hoog - laag);
          kolommen.push({
            vraag: alle[0].vraag, eenheid: alle[0].eenheid || '',
            min: alle[0].min != null ? alle[0].min : Math.max(1, Math.round(laag - marge)),
            max: alle[0].max != null ? alle[0].max : Math.round(hoog + marge)
          });
        });
      }

      function bouwStappen() {
        qFields.innerHTML = '';
        kolommen.forEach(function (k, i) {
          var wrap = document.createElement('div');
          wrap.className = 'mo-quiz__step';
          wrap.dataset.moQuizStep = String(i + 1);
          wrap.hidden = i !== 0;
          var id = 'mo-q-' + i + '-' + Math.random().toString(36).slice(2, 7);
          wrap.innerHTML =
            '<label class="mo-quiz__label" for="' + id + '">' + k.vraag + '</label>' +
            '<div class="mo-quiz__field">' +
              '<input id="' + id + '" type="number" inputmode="numeric" min="' + k.min + '" max="' + k.max + '" step="1" data-mo-quiz-input>' +
              (k.eenheid ? '<span class="mo-quiz__unit">' + k.eenheid + '</span>' : '') +
            '</div>' +
            '<p class="mo-quiz__error" hidden>' + quiz.dataset.error + '</p>';
          qFields.appendChild(wrap);
        });
        qDots.innerHTML = '';
        for (var d = 0; d < kolommen.length + 2; d++) {
          var s = document.createElement('span');
          s.className = 'mo-quiz__dot';
          qDots.appendChild(s);
        }
        qFields.querySelectorAll('[data-mo-quiz-input]').forEach(function (i) {
          i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); qNext.click(); } });
        });
      }

      function stappen() { return [].slice.call(qFields.querySelectorAll('.mo-quiz__step')); }
      function invoer() { return [].slice.call(qFields.querySelectorAll('[data-mo-quiz-input]')); }
      function laatsteMeetstap() { return kolommen.length; }
      function fitStap() { return kolommen.length + 1; }
      function resultStap() { return kolommen.length + 2; }

      function shiftFor(fit) {
        return parseInt(quiz.dataset[fit === 'tight' ? 'tight' : fit === 'loose' ? 'loose' : 'regular'], 10) || 0;
      }
      function chosenFit() {
        var r = quiz.querySelector('[data-mo-quiz-fit]:checked');
        return r ? r.value : 'regular';
      }
      function fitLabel() {
        var r = quiz.querySelector('[data-mo-quiz-fit]:checked');
        return r ? r.parentElement.textContent.trim().toLowerCase() : '';
      }
      function buiten(waarde, van, tot) {
        if (waarde < van) return van - waarde;
        if (waarde > tot) return waarde - tot;
        return 0;
      }
      function sizeValues() {
        return [].slice.call(root.querySelectorAll('[data-mo-option][data-option-position="' + sizePos + '"]'))
          .map(function (i) { return i.value; });
      }
      function variantForSize(label) {
        var probe = selectedOptions().slice();
        probe[sizePos - 1] = label;
        return variantFor(probe);
      }

      function bereken() {
        if (!maten.length) return null;
        var waarden = invoer().map(function (i) { return parseFloat(i.value); });
        var beste = 0, besteScore = Infinity;
        maten.forEach(function (m, i) {
          var score = 0;
          m.velden.forEach(function (v, k) {
            if (!isNaN(waarden[k])) score += buiten(waarden[k], v.van, v.tot);
          });
          if (score < besteScore) { besteScore = score; beste = i; }
        });
        var idx = Math.max(0, Math.min(maten.length - 1, beste + shiftFor(chosenFit())));

        /* Alleen maten voorstellen die het product echt heeft */
        var have = sizeValues();
        if (have.length) {
          var pogingen = 0;
          while (have.indexOf(maten[idx].maat) === -1 && pogingen < maten.length) {
            idx = idx > beste ? idx - 1 : idx + 1;
            idx = Math.max(0, Math.min(maten.length - 1, idx));
            pogingen++;
          }
          if (have.indexOf(maten[idx].maat) === -1) return null;
        }
        return maten[idx].maat;
      }

      function render() {
        stappen().forEach(function (el) { el.hidden = parseInt(el.dataset.moQuizStep, 10) !== step; });
        if (qFitStep) qFitStep.hidden = step !== fitStap();
        if (qResult) qResult.hidden = step !== resultStap();
        [].slice.call(qDots.children).forEach(function (d, i) { d.classList.toggle('is-done', i < step); });
        if (qPrev) qPrev.hidden = step === 1;
        if (qNav) qNav.hidden = step === resultStap();
      }

      function valideer() {
        if (step > laatsteMeetstap()) return true;
        var el = stappen()[step - 1];
        var input = el.querySelector('[data-mo-quiz-input]');
        var v = parseFloat(input.value);
        var ok = v >= parseFloat(input.min) && v <= parseFloat(input.max);
        el.querySelector('.mo-quiz__error').hidden = ok;
        return ok;
      }

      function afronden() {
        recommended = bereken();
        if (!recommended) { step = 1; render(); return; }
        qSizeEl.textContent = recommended;
        var variant = variantForSize(recommended);
        var beschikbaar = !variant || variant.available;
        var samenvatting = invoer().map(function (i, k) {
          return i.value + (kolommen[k].eenheid ? ' ' + kolommen[k].eenheid : '');
        }).join(', ');
        qReason.textContent = quiz.dataset.reason
          .replace('{maten}', samenvatting)
          .replace('{pasvorm}', fitLabel());
        qReason.classList.remove('is-soldout');
        if (!beschikbaar) {
          qReason.textContent = quiz.dataset.soldout;
          qReason.classList.add('is-soldout');
        }
        qApply.textContent = quiz.dataset.apply.replace('{maat}', recommended);
        qApply.disabled = !beschikbaar;
        if (remember) {
          try {
            localStorage.setItem(STORE, JSON.stringify({
              bron: quiz.dataset.source,
              waarden: invoer().map(function (i) { return i.value; }),
              fit: chosenFit()
            }));
          } catch (e) { /* privémodus: gewoon overslaan */ }
        }
        step = resultStap();
        render();
      }

      function init() {
        if (quiz.dataset.source === 'chart') {
          maten = uitMaattabel();
          if (!maten.length) maten = uitInstelling();
        } else {
          maten = uitInstelling();
          /* Alleen maten die ook in de maattabel staan, in dezelfde volgorde.
             Zo kan de quiz nooit een maat adviseren die de tabel niet kent. */
          var ladder = ladderUitTabel();
          if (ladder.length) {
            var opNaam = {};
            maten.forEach(function (m) { opNaam[m.maat] = m; });
            var gefilterd = ladder.map(function (naam) { return opNaam[naam]; }).filter(Boolean);
            if (gefilterd.length) maten = gefilterd;
          }
        }
        bepaalKolommen();
        bouwStappen();
        if (!maten.length) {
          qFields.innerHTML = '<p class="mo-quiz__intro">' + quiz.dataset.nochart + '</p>';
          if (qNav) qNav.hidden = true;
        }
        step = 1;
        render();
      }

      if (qNext) qNext.addEventListener('click', function () {
        if (!valideer()) return;
        if (step === fitStap()) { afronden(); return; }
        step++;
        render();
      });
      if (qPrev) qPrev.addEventListener('click', function () { step = Math.max(1, step - 1); render(); });

      quiz.querySelectorAll('[data-mo-quiz-fit]').forEach(function (r) {
        r.addEventListener('change', function () {
          quiz.querySelectorAll('.mo-quiz__choice').forEach(function (l) {
            l.classList.toggle('is-selected', l.contains(r) && r.checked);
          });
        });
      });

      if (qApply) qApply.addEventListener('click', function () {
        var input = root.querySelector('[data-mo-option][data-option-position="' + sizePos + '"][value="' + recommended + '"]');
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        quiz.close();
      });
      var qRestart = quiz.querySelector('[data-mo-quiz-restart]');
      if (qRestart) qRestart.addEventListener('click', function () { step = 1; render(); });

      if (qOpen) qOpen.addEventListener('click', function () {
        if (!maten.length) init();
        if (remember) {
          try {
            var saved = JSON.parse(localStorage.getItem(STORE) || 'null');
            if (saved && saved.bron === quiz.dataset.source && saved.waarden) {
              invoer().forEach(function (i, k) { if (saved.waarden[k] != null) i.value = saved.waarden[k]; });
              var r = quiz.querySelector('[data-mo-quiz-fit][value="' + saved.fit + '"]');
              if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
            }
          } catch (e) { /* stille terugval */ }
        }
        step = 1; render();
        openDialoog(quiz);
      });
      var qClose = quiz.querySelector('[data-mo-quiz-close]');
      if (qClose) qClose.addEventListener('click', function () { quiz.close(); });
      quiz.addEventListener('click', function (e) { if (e.target === quiz) quiz.close(); });

      init();
    }

    /* ── Sale-countdown: stopt en verbergt zichzelf na de einddatum ── */
    var sale = root.querySelector('[data-mo-sale]');
    if (sale) {
      var end = new Date(sale.dataset.end).getTime();
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tickSale = function () {
        var d = end - Date.now();
        if (isNaN(end) || d <= 0) { sale.hidden = true; clearInterval(saleTimer); return; }
        sale.querySelector('[data-d]').textContent = pad(Math.floor(d / 864e5));
        sale.querySelector('[data-h]').textContent = pad(Math.floor(d % 864e5 / 36e5));
        sale.querySelector('[data-m]').textContent = pad(Math.floor(d % 36e5 / 6e4));
        sale.querySelector('[data-s]').textContent = pad(Math.floor(d % 6e4 / 1e3));
      };
      var saleTimer = setInterval(tickSale, 1000);
      tickSale();
      timers.push(saleTimer);
    }

    /* ── Verzendcutoff: telt af naar het ingestelde uur ── */
    var cutoff = root.querySelector('[data-mo-cutoff]');
    if (cutoff) {
      var hour = parseInt(cutoff.dataset.hour, 10);
      var days = parseInt(cutoff.dataset.cutoffDays, 10) || 1;
      var clock = cutoff.querySelector('[data-mo-clock]');
      var dateEl = cutoff.querySelector('[data-mo-deliver-date]');
      var pad2 = function (n) { return String(n).padStart(2, '0'); };
      var tickCut = function () {
        var now = new Date(), e = new Date(now);
        e.setHours(hour, 0, 0, 0);
        var missed = e <= now;
        if (missed) e.setDate(e.getDate() + 1);
        var d = e - now;
        if (clock) clock.textContent = pad2(Math.floor(d / 36e5)) + ':' + pad2(Math.floor(d % 36e5 / 6e4)) + ':' + pad2(Math.floor(d % 6e4 / 1e3));
        if (dateEl) {
          /* werkdagen tellen, weekend overslaan */
          var del = new Date(now);
          if (missed) del.setDate(del.getDate() + 1);
          var left = days;
          while (left > 0) {
            del.setDate(del.getDate() + 1);
            if (del.getDay() !== 0 && del.getDay() !== 6) left--;
          }
          dateEl.textContent = del.toLocaleDateString(document.documentElement.lang || 'nl-NL',
            { weekday: 'long', day: 'numeric', month: 'long' });
        }
      };
      var cutTimer = setInterval(tickCut, 1000);
      tickCut();
      timers.push(cutTimer);
    }

    /* ── Voorraad per maat op de knop ──
       De badge hoort bij de combinatie van maat én gekozen kleur, dus hij wordt
       telkens opnieuw uit de variantdata gehaald in plaats van serverside gezet. */
    var lowStock = parseInt(root.dataset.lowStock, 10) || 0;
    function variantFor(options) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < options.length; k++) {
          if (variants[i].options[k] !== options[k]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    function updateSizeBadges() {
      var pills = root.querySelectorAll('.mo-pill');
      if (!pills.length) return;
      var sel = selectedOptions();
      pills.forEach(function (label) {
        var input = label.querySelector('input[data-mo-option]');
        if (!input) return;
        var pos = (parseInt(input.dataset.optionPosition, 10) || 1) - 1;
        var probe = sel.slice();
        probe[pos] = input.value;
        var pv = variantFor(probe);
        label.classList.toggle('is-unavailable', !(pv && pv.available));
        var badge = label.querySelector('[data-mo-left]');
        if (!badge) return;
        var q = pv && pv.managed ? pv.qty : null;
        if (lowStock > 0 && q != null && q > 0 && q <= lowStock) {
          badge.textContent = q;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    }

    /* ── Voorraadbalk: volgt de gekozen variant ── */
    var stock = root.querySelector('[data-mo-stock]');
    function updateStock(variant) {
      if (!stock) return;
      var qty = variant && variant.qty != null ? variant.qty : null;
      var managed = variant && variant.managed;
      var threshold = parseInt(stock.dataset.threshold, 10) || 15;
      var total = parseInt(stock.dataset.total, 10) || 25;
      if (!managed || qty == null || qty <= 0 || qty > threshold) { stock.hidden = true; return; }
      stock.hidden = false;
      stock.querySelector('[data-mo-stock-n]').textContent = qty;
      var sizeEl = stock.querySelector('[data-mo-stock-size]');
      if (sizeEl) {
        var pill = root.querySelector('.mo-pills input[data-mo-option]:checked');
        sizeEl.textContent = pill ? pill.value : '';
      }
      var meta = stock.querySelector('[data-mo-stock-meta]');
      if (meta) meta.textContent = stock.dataset.meta || '';
      stock.querySelector('[data-mo-stock-fill]').style.width = Math.max(6, Math.round(qty / total * 100)) + '%';
    }

    /* ── Sticky add to cart ── */
    /* Bewust geen IntersectionObserver: die meldt alleen een *verandering* in
       zichtbaarheid. Wie met één sprong van boven de knop naar ver eronder
       gaat — ankerlink, teruggezette scrollpositie, scrollTo — gaat van "niet
       zichtbaar" naar "niet zichtbaar" en krijgt dus nooit een melding; de
       balk blijft dan weg. Een op rAF gedempte scroll-luisteraar meet de
       positie zelf en klopt ook direct bij het laden. */
    var sticky = root.querySelector('[data-mo-sticky]');
    if (sticky && atc) {
      var wachtOpFrame = false;
      var meetSticky = function () {
        wachtOpFrame = false;
        var r = atc.getBoundingClientRect();
        sticky.classList.toggle('is-visible', r.top < 0);
      };
      var planMeting = function () {
        if (wachtOpFrame) return;
        wachtOpFrame = true;
        window.requestAnimationFrame(meetSticky);
      };
      window.addEventListener('scroll', planMeting, { passive: true });
      window.addEventListener('resize', planMeting);
      root.moStickyOff = function () {
        window.removeEventListener('scroll', planMeting);
        window.removeEventListener('resize', planMeting);
      };
      meetSticky();
    }

    root.moDestroy = function () {
      if (root.moIO) root.moIO.disconnect();
      if (root.moStickyOff) root.moStickyOff();
      timers.forEach(clearInterval);
      root.dataset.moInit = '';
    };

    goTo(0);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mo-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mo-product]').forEach(function (r) {
      if (typeof r.moDestroy === 'function') r.moDestroy();
    });
  });
})();
